// extracted by mini-css-extract-plugin
module.exports = {"boxArea":"subscription-view_boxArea__CUoLg","simpArea":"subscription-view_simpArea__3DeA-"};